/**
 * @module api-web:cc
 * @description
 */
import service from '@/service'
// --------------------------------订单拉取管理-------------------------------------
// --------------------------------订单拉取管理-------------------------------------

/**
 * @description 打开/关闭接口
 */
export function openOrCloseInterfaceApi(data) {
  return service['api-web']({
    url: '/cc/orderPullManagement/openOrCloseInterface',
    method: 'post',
    data
  })
}

/**
 * @description 查询列表
 */
export function getList(data) {
  return service['api-web']({
    url: '/cc/orderPullManagement/getList',
    method: 'post',
    data
  })
}

/**
 * @description 订单拉取
 */
export function orderPullManagementOrderPullApi(data) {
  return service['api-web']({
    url: '/cc/orderPullManagement/orderPull',
    method: 'post',
    data
  })
}

/**
 * @description 订单拉取确认接口
 */
export function orderPullManagementOrderPullConfirmApi(data) {
  return service['api-web']({
    url: '/public/orderPullConfirm',
    method: 'post',
    data
  })
}

/**
 * @description 查询日志
 */
export function orderPullManagementGetOperationLogApi(data) {
  return service['api-web']({
    url: '/cc/orderPullManagement/getOperationLog',
    method: 'post',
    data
  })
}
